export const CACHE_CURRENT_FILTERS = 'CACHE_CURRENT_FILTERS';
export const REMOVE_CURRENT_FILTER_ITEM = 'REMOVE_CURRENT_FILTER_ITEM';
export const RESET_CACHED_FILTERS = 'RESET_CACHED_FILTERS';
export const RESET_CURRENT_FILTER = 'RESET_CURRENT_FILTER';
export const RESET_CURRENT_FILTERS = 'RESET_CURRENT_FILTERS';
export const SET_CURRENT_FILTERS = 'SET_CURRENT_FILTERS';
export const SET_CURRENT_FILTERS_FROM_CACHE = 'SET_CURRENT_FILTERS_FROM_CACHE';
export const SET_FILTER_OVERLAY_VISIBLE = 'SET_FILTER_OVERLAY_VISIBLE';
export const SET_CURRENT_CURATED_PICK_FILTER =
  'SET_CURRENT_CURATED_PICK_FILTER';
export const RESET_CURRENT_CURATED_PICK_FILTER =
  'RESET_CURRENT_CURATED_PICK_FILTER';
export const CACHE_CURATED_PICK_FILTER = 'CACHE_CURATED_PICK_FILTER';
export const SET_CURRENT_CURATED_PICK_FILTER_FROM_CACHE =
  'SET_CURRENT_CURATED_PICK_FILTER_FROM_CACHE';
